<form [formGroup]="distributionAccountCreateForm" (submit)="create()" id="form-create-distribution-account">
  <button mat-icon-button
          id="button-dialog-close"
          class="mat-icon-button-small"
          data-cy="button-dialog-close"
          [mat-dialog-close]="true">
    <mat-icon>clear</mat-icon>
  </button>
  <h5 mat-dialog-title>Create Distribution Account</h5>
  <div mat-dialog-content class="mat-body-1">
    <p>Create a new Distribution Account.</p>
    <p *ngIf="errorMessage" class="error" id="error-feedback">{{errorMessage}}</p>
    <mat-form-field id="distribution-account-description-form">
      <input #distributionAccountDescription
             formControlName="description"
             class="form-input"
             id="distribution-account-description"
             matInput
             maxlength="500"
             name="distribution-account-description"
             placeholder="Distribution Account Description">
      <mat-hint align="end">{{distributionAccountDescription.value.length || 0}} / 500</mat-hint>
      <mat-error *ngIf="distributionAccountCreateForm.get('description')?.hasError('required')">
        Distribution account description is empty
      </mat-error>
    </mat-form-field>

    <app-input-dropdown
      id="target-system-id-dropdown"
      elementId="target-system-id-form"
      [data]="allTargetSystems"
      [inputControl]="targetSystemIdControl"
      label="Target System"
      orderByValue="targetId"
      placeholder="Target System">
    </app-input-dropdown>

    <mat-form-field id="foreign-account-id-form">
      <input #foreignAccountIdInput
             formControlName="foreignAccountId"
             class="form-input"
             id="foreign-account-id"
             matInput
             maxlength="500"
             name="foreign-account-id"
             placeholder="Foreign account ID">
      <mat-hint align="end">{{foreignAccountIdInput.value.length || 0}} / 500</mat-hint>
      <mat-error *ngIf="distributionAccountCreateForm.get('foreignAccountId')?.hasError('required')">
        Missing Foreign account ID
      </mat-error>
    </mat-form-field>

    <app-input-dropdown
      id="segment-id-dropdown"
      elementId="segment-id-form"
      [data]="allSegments"
      [inputControl]="segmentIdControl"
      label="Segment"
      orderByValue="id"
      placeholder="Segment">
    </app-input-dropdown>

    <mat-form-field
      id="foreign-segment-id-form"
      formGroupName="initialSegmentMapping">
      <input #foreignIdInput
             formControlName="foreignId"
             [placeholder]="foreignIdInput.disabled ? '-automatically set foreign segment id-' : 'Foreign Segment ID'"
             class="form-input"
             id="foreign-segment-id"
             matInput
             maxlength="500"
             name="foreign-segment-id">
      <mat-hint *ngIf="segmentIdDisabled"
                align="end">{{foreignIdInput.value.length || 0}} / 500
      </mat-hint>
      <mat-error
        *ngIf="distributionAccountCreateForm.get('initialSegmentMapping')?.get('foreignId')?.hasError('required')">
        Missing Foreign segment ID
      </mat-error>
    </mat-form-field>

    <mat-slide-toggle formControlName="visibleForAll">Visible for all partners</mat-slide-toggle>
  </div>
  <div mat-dialog-actions>
    <button type="button" (click)="reset()" mat-raised-button>Reset</button>
    <button type="submit" color="primary" id="button-create-distribution-account" mat-raised-button>Create</button>
  </div>
</form>
